import treasure1 from "src/assets/images/expeditions/treasure1.png";
import { environment } from "./constance";

const treasureMapTestnet = {
  limited: {
    id: "limited",
    name: "Limited",
    title: "Treasure Hunt: Mt.Garg",
    acceptableRarities: [1, 2, 3, 4, 5, 6],
    description: `“Aries 14, 1042.\n
    A bold attempt made by the Darkbeard pirates, when they infiltrated the Citadel under the disguise of knight recruits and stowed away a remarkable number of armoury chests.\n
    Just when the pirates thought they had succeeded, Holy Knights of Trava discovered the heist and gave chase. Encircled, the pirates crossed Rudriz Pass and fled south towards the Southern Empty.\n
    Aries 20, 1042.\n
    Unbeknownst to them, the Southern Empty is not an amicable place for knights and pirates alike, and sooneth they discovered that their hair fall, their skins peeled, and their lives were withering away.\n
    Desperate, the Darkbeard pirates retreated to the foot of the lonely mountain, and there, one by one, they succumbed to ever darkness, lying on the stone cold chests they gave their lives for.”`,
    contractAddress: "0x687Bd9467686809B22F8dF3EfC34D49fE89621A6",
    order: 0,
    img: treasure1,
    color: "#433214",
    status: "available",
  },
};

const treasureMapMainnet = {
  limited: {
    id: "limited",
    name: "Limited",
    title: "Treasure Hunt: Mt.Garg",
    acceptableRarities: [1, 2, 3, 4, 5, 6],
    description: `“Aries 14, 1042.\n
    A bold attempt made by the Darkbeard pirates, when they infiltrated the Citadel under the disguise of knight recruits and stowed away a remarkable number of armoury chests.\n
    Just when the pirates thought they had succeeded, Holy Knights of Trava discovered the heist and gave chase. Encircled, the pirates crossed Rudriz Pass and fled south towards the Southern Empty.\n
    Aries 20, 1042.\n
    Unbeknownst to them, the Southern Empty is not an amicable place for knights and pirates alike, and sooneth they discovered that their hair fall, their skins peeled, and their lives were withering away.\n
    Desperate, the Darkbeard pirates retreated to the foot of the lonely mountain, and there, one by one, they succumbed to ever darkness, lying on the stone cold chests they gave their lives for.”`,
    contractAddress: "0x248C38Ff4A6723069B40bCb5Ea0D50C3D96D0439",
    order: 0,
    img: treasure1,
    color: "#433214",
    status: "available",
  },
};

const treasureMapConfig = environment === "testnet" ? treasureMapTestnet : treasureMapMainnet;

export default treasureMapConfig;
